/**
 * Calendar Configuration
 *
 * Central configuration for calendar-specific settings
 */

/**
 * Blueprint AI Class Configuration
 *
 * To find the recurring event ID for your Blueprint AI classes:
 * 1. Open the event in Google Calendar
 * 2. Click "More actions" → "Publish event"
 * 3. The recurring event ID is in the URL after "eid="
 *
 * OR check the browser console - the recurringEventId will be logged
 * when you view the event in the calendar.
 */
export const BLUEPRINT_AI_CONFIG = {
  // The recurring event ID for your Blueprint AI class series
  // This stays the same across all occurrences of the recurring event
  recurringEventId: "226ca61c4f6a4b6cb32aac1a71e3f753_R20251023T210000",

  // Signup/registration settings
  enableSignup: true,

  // Display settings
  signupButtonText: "Sign Up for This Class",
  signupButtonVariant: "primary" as const,

  // Where to send users when they click signup
  // TODO: Replace with your actual Notion form URL
  signupUrl: "https://your-notion-form-url-here.com",
};

/**
 * Helper function to check if an event is a Blueprint AI class
 */
export const isBlueprintAIClass = (event: {
  recurringEventId?: string;
}): boolean => {
  if (!event.recurringEventId) {
    return false;
  }

  return event.recurringEventId === BLUEPRINT_AI_CONFIG.recurringEventId;
};

export default BLUEPRINT_AI_CONFIG;
